@if (events() && events().length > 0) {
  <section>
    <h2 class="gs1-h2 font-500">{{ 'home.agenda.title' | translate }}</h2>

    <div class="cards-list gs1-spacing-2xl">
      @for (event of events(); track $index) {
        <gs1-card-event [config]="config()" [title]="event.title" [text]="event.summary" [place]="event.city" [date]="event.startDate" [visio]="checkEventFormat(event.format)">
          <gs1-chip class="bi" [color]="'pale-blue'">{{ event.sector }}</gs1-chip>
          <gs1-chip [color]="'pale-blue'">{{ event.type }}</gs1-chip>
          <img [src]="event.image" alt="Illustration" card-illustration />
          <a gs1Button color="blue" [href]="event.url" target="_blank" (click)="trackEvent(event.title)">{{ 'home.agenda.event-button' | translate }}</a>
        </gs1-card-event>
      }
    </div>

    <div class="flex justify-center">
      <a gs1Button color="orange" href="https://www.gs1.fr/agenda" target="_blank" (click)="trackAllEvents()">{{ 'home.agenda.all-button' | translate }}</a>
    </div>
  </section>
}
